import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { styled } from '@mui/material';
import MenuItem from './MenuItem.js';
import { ReactComponent as ForwardRef } from '../../../assets/icons/CheckSmall.svg.js';
import { useOverflow } from '../OverflowProvider.js';
import { ChecklistItemsContext } from '../hooks/useChecklist.js';

const _CheckSmall = styled(ForwardRef, {
    shouldForwardProp: prop => !['dense', 'checked'].includes(prop),
}) `
  transition: opacity ${({ theme }) => theme.transitions.duration.fast} linear;
  ${({ checked, dense, theme }) => `
    opacity: ${checked ? 1 : 0};
    margin: ${theme.spacing(0, 0, 0, dense ? 1 : 0)};
  `}
`;
const ChecklistItems = ({ options, onOptionsUpdate }) => {
    const { dense } = useOverflow();
    const onItemClick = useCallback((name) => {
        onOptionsUpdate(options.map(option => (option.name !== name ? option : Object.assign(Object.assign({}, option), { selected: !option.selected }))));
    }, [onOptionsUpdate, options]);
    return (jsx(ChecklistItemsContext.Provider, Object.assign({ value: true }, { children: options.map((_a) => {
            var { name, label, selected } = _a, rest = __rest(_a, ["name", "label", "selected"]);
            return (jsx(MenuItem, Object.assign({}, rest, { preventMenuClose: true, onClick: () => onItemClick(name), "data-testid": `checklist-item-${label}`, leftIcon: jsx(_CheckSmall, { checked: selected, dense: dense, "data-testid": "check-box", "data-test-checked": selected ? 'checked' : 'unchecked' }) }, { children: label }), name));
        }) })));
};

export { ChecklistItems as default };
//# sourceMappingURL=ChecklistItems.js.map
